import React, { useMemo } from 'react';
import {
  PHONE_COUNTRIES,
  countryCodeToFlag,
  formatPhoneCountryOption,
} from '../data/phoneCountries';
import './PhoneCountryInput.css';

/**
 * Prefijo de país (lista desplazable) + número local.
 * @param {boolean} [compact] — select estrecho con solo +XX (p. ej. modal de reservas)
 */
export default function PhoneCountryInput({
  countryCode,
  onCountryCodeChange,
  local,
  onLocalChange,
  disabled = false,
  compact = false,
  selectId,
  inputId,
  labelledBy,
  placeholder,
  inputAutoComplete = 'tel-national',
}) {
  const handleLocalChange = (e) => {
    const digits = String(e.target.value || '').replace(/\D/g, '').slice(0, 14);
    onLocalChange(digits);
  };

  const selectedCountry = useMemo(
    () => PHONE_COUNTRIES.find((c) => c.code === countryCode) || PHONE_COUNTRIES[0],
    [countryCode]
  );

  return (
    <div
      className={`phone_country_row${compact ? ' phone_country_row--compact' : ''}`}
    >
      <div
        className={`phone_country_select_wrap${
          compact ? ' phone_country_select_wrap--compact' : ''
        }`}
      >
        {compact ? (
          <span className="phone_country_select_display" aria-hidden="true">
            <span className="phone_country_select_flag">
              {countryCodeToFlag(selectedCountry.code)}
            </span>
            <span className="phone_country_select_dial">{selectedCountry.dial}</span>
          </span>
        ) : null}
        <select
          id={selectId}
          className={`phone_country_select${
            compact ? ' phone_country_select--overlay' : ''
          }`}
          value={countryCode}
          onChange={(e) => onCountryCodeChange(e.target.value)}
          disabled={disabled}
          aria-labelledby={labelledBy}
        >
          {PHONE_COUNTRIES.map((c) => (
            <option key={c.code} value={c.code}>
              {formatPhoneCountryOption(c, { compact: false })}
            </option>
          ))}
        </select>
      </div>
      <input
        id={inputId}
        type="tel"
        inputMode="numeric"
        className="phone_country_input"
        value={local}
        onChange={handleLocalChange}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete={inputAutoComplete}
        aria-labelledby={labelledBy}
      />
    </div>
  );
}
